var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-pr-close",
  "use": "ring-icon-pr-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-pr-close\"><path d=\"M6 4a2 2 0 1 0-2.7 1.87v5.26a2 2 0 1 0 1.4 0V5.87A2 2 0 0 0 6 4zm-2 9.6a.6.6 0 1 1 .6-.6.6.6 0 0 1-.6.6zm0-9a.6.6 0 1 1 .6-.6.6.6 0 0 1-.6.6zM14 6l1-.93-1.6-1.57L15 1.93 14 1l-1.53 1.57L10.9 1l-.9.93 1.53 1.57L10 5.07l.9.93.87-.87v6a2 2 0 1 0 1.4 0v-6zm-1.56 7.6a.6.6 0 1 1 .6-.6.6.6 0 0 1-.57.6z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id